import DatePagination from './DatePagination'

export default DatePagination
